// extracted by mini-css-extract-plugin
module.exports = {"root":"ButtonSocial_root__6KpWp","label":"ButtonSocial_label__ifK8s","icon":"ButtonSocial_icon__VLXCq","rotation":"ButtonSocial_rotation__H44ff"};